import { createClient } from '@libsql/client';

export const client = createClient({
   url: import.meta.env.VITE_APP_TURSO_DATABASE_URL,
   authToken: import.meta.env.VITE_APP_TURSO_AUTH_TOKEN,
});
